import { Literal, Object, Union, Number, String, Optional, Array, Static } from '@sinclair/typebox';

export type UpsellTableTabPrice = Static<typeof UpsellTableTabPrice>;
export const UpsellTableTabPrice = Union([
  Object({ type: Literal('revenue'), totalPrice: Number() }),
  Object({ type: Literal('points'), points: Number() }),
]);

export type UpsellTableTab = Static<typeof UpsellTableTab>;
export const UpsellTableTab = Object({
  date: String(),
  /** @deprecated use priceV2 instead, we only keep price for backwards compatibility with the app  */
  price: Union([Number(), Literal('NA')]),
  priceV2: Optional(UpsellTableTabPrice),
});

export const UpsellTableColumns = Object({
  outbound: Optional(Array(String())),
  inbound: Optional(Array(String())),
});

export type UpsellTableTabs = Static<typeof UpsellTableTabs>;
export const UpsellTableTabs = Object({
  outbound: Optional(Array(UpsellTableTab)),
  inbound: Optional(Array(UpsellTableTab)),
});

export type UpsellTable = Static<typeof UpsellTable>;
export const UpsellTable = Object({
  tabs: Optional(UpsellTableTabs),
  columns: Optional(UpsellTableColumns),
});
